/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface TenantFeatureSettingsEntity
 */
export interface TenantFeatureSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof TenantFeatureSettingsEntity
     */
    key?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantFeatureSettingsEntity
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantFeatureSettingsEntity
     */
    label?: string;
}

/**
 * Check if a given object implements the TenantFeatureSettingsEntity interface.
 */
export function instanceOfTenantFeatureSettingsEntity(value: object): boolean {
    return true;
}

export function TenantFeatureSettingsEntityFromJSON(json: any): TenantFeatureSettingsEntity {
    return TenantFeatureSettingsEntityFromJSONTyped(json, false);
}

export function TenantFeatureSettingsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantFeatureSettingsEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function TenantFeatureSettingsEntityToJSON(value?: TenantFeatureSettingsEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'enabled': value['enabled'],
        'label': value['label'],
    };
}

